import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core"
import { CommonModule } from "@angular/common"
import { FormsModule } from "@angular/forms"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatSelectModule } from "@angular/material/select"
import { OwnerService } from "../../services/owner.service"
import { StationService } from "../../services/station.service"
import {
  OwnerListItem,
  OwnerStationFilterValues,
  StationFilterItem,
} from "../../models/filter.model"

@Component({
  selector: "app-owner-station-filters",
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule],
  templateUrl: "./owner-station-filters.component.html",
  styleUrl: "./owner-station-filters.component.css",
})
export class OwnerStationFiltersComponent implements OnInit {
  @Input() showOwner = true
  @Input() showStation = true
  /** Logged-in user's role (e.g. 'admin' | 'owner' | 'user'). Controls which dropdowns render. */
  @Input() userRole = ""
  @Output() filterChange = new EventEmitter<OwnerStationFilterValues>()

  owners: OwnerListItem[] = []
  allStations: StationFilterItem[] = []
  loadingOwners = false
  loadingStations = false

  selectedOwnerId: number | "" = ""
  selectedStationId: number | "" = ""

  constructor(
    private ownerService: OwnerService,
    private stationService: StationService,
  ) {}

  ngOnInit(): void {
    if (this.canShowOwner) {
      this.loadingOwners = true
      this.ownerService.getAllOwners().subscribe({
        next: (owners) => {
          this.owners = owners
          this.loadingOwners = false
        },
        error: () => {
          this.loadingOwners = false
        },
      })
    }

    if (this.canShowStation) {
      this.loadingStations = true
      this.stationService.getAllStationsForFilter().subscribe({
        next: (stations) => {
          this.allStations = stations
          this.loadingStations = false
        },
        error: () => {
          this.loadingStations = false
        },
      })
    }
  }

  private get normalizedRole(): string {
    return (this.userRole || "").toLowerCase()
  }

  /** Only admins may filter by owner. */
  get canShowOwner(): boolean {
    return this.showOwner && this.normalizedRole === "admin"
  }

  /** Station-facing roles (everyone except regular users) may filter by station. */
  get canShowStation(): boolean {
    const r = this.normalizedRole
    return this.showStation && r !== "" && r !== "user"
  }

  get filteredStations(): StationFilterItem[] {
    if (this.selectedOwnerId === "") {
      return this.allStations
    }
    const ownerId = Number(this.selectedOwnerId)
    return this.allStations.filter((s) => s.owner_id === ownerId)
  }

  onOwnerChange(): void {
    if (this.selectedStationId !== "") {
      const stationId = Number(this.selectedStationId)
      const stillValid = this.filteredStations.some((s) => s.id === stationId)
      if (!stillValid) {
        this.selectedStationId = ""
      }
    }
    this.emitChange()
  }

  onStationChange(): void {
    this.emitChange()
  }

  private emitChange(): void {
    this.filterChange.emit({
      ownerId: this.selectedOwnerId === "" ? null : Number(this.selectedOwnerId),
      stationId: this.selectedStationId === "" ? null : Number(this.selectedStationId),
    })
  }
}
